<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t("title.param.control") }}
      </h1>

      <div class="card rounded-0 mb-4">
        <form
          class="card-body"
          @submit.prevent="submitFile()"
        >
          <div class="row mb-2">
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t("label.param.paramFile") }}
              </label>
              <input
                id="file"
                ref="file"
                type="file"
                accept=".xls, .xlsx"
                @change="handleFileUpload()"
              >
            </div>
          </div>

          <div class="row mb-2">
            <div class="col justify-content-end text-end criteria-button">
              <button
                class="
                  btn btn-primary btn-submit
                  rounded-pill
                  font-custom
                  text-uppercase
                  font-inverted
                "
                type="submit"
              >
                {{ $t("button.control") }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="center-block"
        >
      </div>

      <div v-if="!!errormessages">
        <div v-if="errormessages.length">
          <div
            v-for="errormessage in errormessages"
            :key="errormessage"
            class="alert alert-warning text-center border-0 shadow-sm rounded-0"
          >
            {{ errormessage }}
          </div>
        </div>
      </div>
      <div v-if="!!productviolations">
        <div v-if="productviolations.length">
          <label class="control-label fw-bold mb-1">
            {{ $t("label.param.productViolationslist") }} {{ fileName }}
          </label>

          <div class="table-responsive">
            <table class="table table-hover table-sm table-striped border">
              <tbody
                v-for="productviolation in productviolations"
                :key="productviolation.productRef"
              >
                <tr
                  class="mb-3"
                >
                  <td
                    class="fw-bold"
                  >
                    {{ productviolation.productRef }}
                  </td>
                  <td
                    class="fw-bold"
                  >
                    {{ $t("label.param.violations") }}
                  </td>
                </tr>
                <tr
                  v-for="violation in productviolation.violations"
                  :key="violation.name"
                >
                  <td
                    class="text-end"
                  >
                    •
                  </td>
                  <td>{{ violation.name }} : {{ violation.message }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-else-if="isControlled">
        <label class="control-label fw-bold mb-1">
          {{ $t("error.PARAM_CONTROL_NO_RESULT") }} {{ fileName }}
        </label>
        <div v-if="hasPermission('param:difference')">
          <div v-if="!!productdifferences">
            <div v-if="productdifferences.length">
              <label class="control-label fw-bold mb-1">
                {{ $t("label.param.productDifferenceslist") }} {{ fileName }}
              </label>

              <div
                v-if="productdifferences.length"
                id="accordion"
              >
                <div
                  v-for="productdifference in productdifferences"
                  :key="productdifference.productRef"
                  class="card rounded-0 mb-4"
                >
                  <div
                    :id="'heading' + productdifference.productRef"
                    data-bs-toggle="collapse"
                    :href="'#collapse' + productdifference.productRef"
                    aria-expanded="false"
                    :aria-controls="'collapse' + productdifference.productRef"
                    class="card-header font-accent fw-bold"
                  >
                    {{ productdifference.productRef }}
                  </div>
                  <div
                    :id="'collapse' + productdifference.productRef"
                    :aria-labelledby="'heading' + productdifference.productRef"
                    data-bs-parent="#accordion"
                    class="card-body collapse"
                  >
                    <template v-if="productdifference.differences">
                      <table
                        class="table table-hover table-sm table-striped border"
                      >
                        <thead>
                          <tr>
                            <th>Paramètre</th>
                            <th>Paramétrage système</th>
                            <th>Dossier de paramétrage</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="difference in productdifference.differences"
                            :key="difference.code"
                            class="mb-3"
                          >
                            <td>
                              {{ difference.code }} ({{
                                difference.description
                              }})
                            </td>
                            <td>
                              <div
                                v-for="rightValue in difference.rightValue"
                                :key="rightValue.index"
                              >
                                {{ rightValue }} <br>
                              </div>
                            </td>
                            <td>
                              <div
                                v-for="leftValue in difference.leftValue"
                                :key="leftValue.index"
                              >
                                {{ leftValue }} <br>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                    <template v-else>
                      <label class="control-label fw-bold mb-1">
                        {{ productdifference.diffTypeDesc }}
                      </label>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="isControlled">
            <label class="control-label fw-bold mb-1">
              {{ $t("error.PARAM_CONTROL_NO_DIFFERENCE") }} {{ fileName }}
            </label>
          </div>
        </div>
      </div>

      <div
        v-if="error"
        class="alert alert-warning text-center border-0 shadow-sm rounded-0"
      >
        {{ $t("error." + `${responseErr}`) }} {{ fileName }}
      </div>
    </div>
  </div>
</template>

<script src="./ControlParam.js"></script>

<style src="./ControlParam.scss" scoped lang="scss"></style>
